import { Car, Bike, Clock, Truck, Wrench, Gavel, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SERVICES, waLink } from "@/data/content";

const ICONS = { Car, Bike, Clock, Truck, Wrench, Gavel };
const EASE = [0.76, 0, 0.24, 1];

export const Services = () => {
  return (
    <section id="servicos" data-testid="services-section" className="bg-[#111111] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <div className="mb-3 flex items-center gap-3">
              <span className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
                / 01 — Serviços
              </span>
            </div>
            <h2 className="font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-6xl">
              O que fazemos
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-base text-zinc-400">
              Remoção de veículos leves e motocicletas com equipamento próprio e
              equipe pronta 24 horas por dia.
            </p>
          </Reveal>
        </div>

        {/* Bento grid: 6 service cards + full-width CTA */}
        <div className="grid grid-cols-1 gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.06, ease: EASE }}
                className="group relative flex flex-col justify-between gap-8 bg-[#1A1A1A] p-8 transition-colors duration-300 hover:bg-[#161616]"
              >
                <div className="flex items-start justify-between">
                  <Icon size={32} className="text-[#D50000]" strokeWidth={1.6} />
                  <ArrowUpRight
                    size={20}
                    className="text-zinc-600 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-white"
                  />
                </div>
                <div>
                  <h3 className="font-display text-xl font-semibold uppercase tracking-tight text-white">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
                </div>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#D50000] transition-all duration-300 group-hover:w-full" />
              </motion.div>
            );
          })}

          {/* Full-width conversion banner */}
          <motion.a
            data-testid="services-cta-btn"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.1, ease: EASE }}
            className="group relative flex flex-col items-start justify-between gap-6 bg-[#D50000] p-8 transition-colors duration-300 hover:bg-[#B00000] md:col-span-3 md:flex-row md:items-center"
          >
            <div>
              <span className="font-mono-t text-xs uppercase tracking-widest text-white/80">
                Orçamento imediato
              </span>
              <h3 className="mt-2 font-display text-2xl font-semibold uppercase leading-none tracking-tight text-white sm:text-3xl">
                Solicite seu guincho agora pelo WhatsApp
              </h3>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-white/85">
                Fale com nossa equipe e receba o preço na hora, com atendimento 24 horas.
              </p>
            </div>
            <span className="flex shrink-0 items-center gap-3 bg-[#111111] px-6 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-200 group-hover:bg-black">
              Solicitar agora
              <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
            </span>
          </motion.a>
        </div>
      </div>
    </section>
  );
};
